/**
 * Moliani — „Nasze produkty w Waszych domach” (sections/home-reviews-gallery.liquid).
 *
 * Serwer renderuje karty tekstowe z migawki opinii (bez zdjęć). Gdy sekcja
 * zbliża się do ekranu, ten skrypt:
 *  1. pobiera zatwierdzone opinie z App Proxy (ten sam endpoint co
 *     assets/product-reviews.js) — URL-e zdjęć są podpisywane w oknach 1h (ważne 1–2h),
 *     więc przeglądarka trzyma zdjęcia w cache między odsłonami,
 *  2. układa opinie ze zdjęciami na początku, potem dłuższe opinie tekstowe,
 *  3. dociąga miniaturę i cenę produktu z /products/<handle>.js.
 * Jeśli zdjęcie się nie wczyta (np. URL wygasł, bo karta czekała zbyt długo),
 * lista jest pobierana ponownie raz i adresy podmieniane.
 * Błąd pobierania = zostają karty z serwera; logujemy go w konsoli.
 */
(function () {
  'use strict';

  var LIST_ENDPOINT = '/apps/moliani-try-in-room/reviews-list';
  var FETCH_LIMIT = 30;
  var MIN_TEXT_ONLY_LENGTH = 40;
  var STAR = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 0.5L10.0784 5.63932L15.6085 6.02786L11.3629 9.59268L12.7023 14.9721L8 12.036L3.29772 14.9721L4.63706 9.59268L0.391548 6.02786L5.92159 5.63932L8 0.5Z" fill="currentColor"/></svg>';
  var FIVE = STAR + STAR + STAR + STAR + STAR;
  var CHECK = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var productCache = {};

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function stars(rating) {
    var percent = Math.max(0, Math.min(100, (parseFloat(rating) || 0) * 20));
    var span = el('span', 'rating-stars');
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', rating + '/5');
    span.style.setProperty('--rating-percent', percent + '%');
    span.innerHTML = '<span class="rating-stars__bg">' + FIVE + '</span><span class="rating-stars__fg">' + FIVE + '</span>';
    return span;
  }

  // Język sklepu z <html lang> (pl / de / …) — daty i ceny w formacie bieżącej wersji językowej.
  var pageLang = document.documentElement.lang || 'pl';
  var reviewLocale = pageLang.slice(0, 2).toLowerCase();

  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle);
  }

  function formatDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(pageLang, { year: 'numeric', month: 'long', day: 'numeric' });
    } catch (e) {
      return d.toLocaleDateString();
    }
  }

  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    // /products/<handle>.js zwraca cenę w walucie bieżącego rynku (PLN / EUR).
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
    try {
      return new Intl.NumberFormat(pageLang, { style: 'currency', currency: currency, maximumFractionDigits: value % 1 ? 2 : 0 }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + currency;
    }
  }

  function sizedImage(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(productUrl(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .catch(function (err) {
          console.error('[home-reviews] product ' + handle + ' not loaded:', err);
          return null;
        });
    }
    return productCache[handle];
  }

  function pickRows(rows, max) {
    var withPhoto = [];
    var textOnly = [];
    rows.forEach(function (row) {
      if (row.photoUrl) withPhoto.push(row);
      else if ((row.body || '').trim().length >= MIN_TEXT_ONLY_LENGTH) textOnly.push(row);
    });
    return withPhoto.concat(textOnly).slice(0, max);
  }

  function buildProductLink(row, i18n) {
    var link = el('a', 'hrg-card__product');
    link.href = productUrl(row.productHandle);
    var text = el('span', 'hrg-card__product-text');
    text.appendChild(el('span', 'hrg-card__product-label', i18n.productLabel));
    text.appendChild(el('span', 'hrg-card__product-title', row.productTitle));
    link.appendChild(text);
    link.appendChild(el('span', 'hrg-card__product-arrow', '→')).setAttribute('aria-hidden', 'true');

    fetchProduct(row.productHandle).then(function (product) {
      if (!product) return;
      if (product.featured_image) {
        var thumb = el('img', 'hrg-card__product-thumb');
        thumb.src = sizedImage(product.featured_image, 160);
        thumb.alt = '';
        thumb.width = 52;
        thumb.height = 52;
        thumb.loading = 'lazy';
        link.insertBefore(thumb, text);
      }
      if (product.price) {
        var price = (product.price_varies ? i18n.priceFrom + ' ' : '') + formatMoney(product.price);
        text.appendChild(el('span', 'hrg-card__product-price', price));
      }
    });
    return link;
  }

  function buildCard(row, i18n, onPhoto, eager) {
    var card = el('article', 'hrg-card' + (row.photoUrl ? '' : ' hrg-card--quote'));
    card.setAttribute('data-review-id', row.id);

    if (row.photoUrl) {
      var photoBtn = el('button', 'hrg-card__photo');
      photoBtn.type = 'button';
      photoBtn.setAttribute('aria-label', i18n.openPhoto + ' — ' + row.firstName);
      var img = el('img');
      // Karta: mała miniatura WebP; oryginał tylko w lightboksie.
      img.src = row.photoThumbUrl || row.photoUrl;
      img.alt = i18n.photoAlt + (row.productTitle ? ': ' + row.productTitle : '');
      img.loading = eager ? 'eager' : 'lazy';
      img.decoding = 'async';
      img.width = 400;
      img.height = 500;
      photoBtn.appendChild(img);
      var badge = el('span', 'hrg-card__photo-badge');
      badge.innerHTML = STAR;
      badge.appendChild(document.createTextNode(String(row.rating) + '/5'));
      photoBtn.appendChild(badge);
      photoBtn.addEventListener('click', function () { onPhoto(card.__hrgRow || row, img); });
      card.appendChild(photoBtn);
    }

    var body = el('div', 'hrg-card__body');
    if (!row.photoUrl) {
      body.appendChild(el('span', 'hrg-card__quote-mark', '“')).setAttribute('aria-hidden', 'true');
    }
    body.appendChild(stars(row.rating));

    var text = el('p', 'hrg-card__text', (row.body || '').trim());
    if (row.lang) text.setAttribute('lang', row.lang);
    body.appendChild(text);
    // Dopisek o tłumaczeniu i "Pokaż oryginał" wyłączone na życzenie właściciela (2026-10-27).
    // if (row.translatedFrom) {
    //   body.appendChild(el('p', 'hrg-card__translated', i18n.translatedFrom[row.translatedFrom] || i18n.translatedGeneric));
    // }

    var author = el('p', 'hrg-card__author');
    author.appendChild(el('strong', null, row.firstName || ''));
    if (row.verifiedPurchase) {
      var verified = el('span', 'hrg-card__verified');
      verified.innerHTML = CHECK;
      verified.appendChild(document.createTextNode(i18n.verified));
      author.appendChild(verified);
    }
    var date = formatDate(row.submittedAt);
    if (date) author.appendChild(el('span', 'hrg-card__date', date));
    body.appendChild(author);

    if (row.productHandle && row.productTitle) {
      body.appendChild(buildProductLink(row, i18n));
    }
    card.appendChild(body);

    // „Czytaj więcej” tylko gdy tekst faktycznie jest ucięty
    requestAnimationFrame(function () {
      if (text.scrollHeight - text.clientHeight > 2) {
        var more = el('button', 'hrg-card__more', i18n.readMore);
        more.type = 'button';
        more.addEventListener('click', function () {
          var expanded = text.classList.toggle('is-expanded');
          more.textContent = expanded ? i18n.readLess : i18n.readMore;
        });
        text.insertAdjacentElement('afterend', more);
      }
    });

    return card;
  }

  function initSection(root) {
    var track = root.querySelector('[data-role="track"]');
    var prev = root.querySelector('[data-role="prev"]');
    var next = root.querySelector('[data-role="next"]');
    var dialog = root.querySelector('[data-role="lightbox"]');
    var dialogImg = root.querySelector('[data-role="lightbox-img"]');
    var dialogCaption = root.querySelector('[data-role="lightbox-caption"]');
    var shopDomain = root.getAttribute('data-shop-domain') || '';
    var max = parseInt(root.getAttribute('data-max-items'), 10) || 12;
    var i18n = {
      verified: root.getAttribute('data-i18n-verified') || '',
      productLabel: root.getAttribute('data-i18n-product-label') || '',
      photoAlt: root.getAttribute('data-i18n-photo-alt') || '',
      openPhoto: root.getAttribute('data-i18n-open-photo') || '',
      readMore: root.getAttribute('data-i18n-read-more') || '',
      readLess: root.getAttribute('data-i18n-read-less') || '',
      priceFrom: root.getAttribute('data-i18n-price-from') || '',
      translatedFrom: {
        pl: root.getAttribute('data-i18n-translated-from-pl') || '',
        de: root.getAttribute('data-i18n-translated-from-de') || ''
      },
      translatedGeneric: root.getAttribute('data-i18n-translated-generic') || ''
    };
    var retried = false;
    var latestAggregate = null;

    // Pigułka z oceną: serwer renderuje ją z metafieldu, tu podmieniamy na świeży agregat z API
    function updateAggregate() {
      var agg = latestAggregate;
      var wrap = root.querySelector('.hrg__aggregate');
      var template = root.getAttribute('data-i18n-aggregate') || '';
      if (!agg || !agg.count || !wrap || !template) return;
      var avg = Number(agg.average).toFixed(1);
      var label = template.split('__AVG__').join(avg).split('__COUNT__').join(String(agg.count));
      var textNode = wrap.querySelector('.hrg__aggregate-text');
      var starsNode = wrap.querySelector('.rating-stars');
      if (textNode) textNode.textContent = label;
      if (starsNode) {
        starsNode.style.setProperty('--rating-percent', Math.max(0, Math.min(100, avg * 20)) + '%');
        starsNode.setAttribute('aria-label', label);
      }
    }

    // ---------- strzałki ----------
    function step() {
      var card = track.querySelector('.hrg-card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); }, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // ---------- lightbox ----------
    function openPhoto(row, img) {
      if (!dialog || typeof dialog.showModal !== 'function') {
        window.open(row.photoUrl || img.currentSrc || img.src, '_blank', 'noopener');
        return;
      }
      dialogImg.src = row.photoUrl || img.currentSrc || img.src;
      dialogImg.alt = img.alt;
      dialogCaption.textContent = '';
      dialogCaption.appendChild(el('strong', null, row.firstName + ' '));
      dialogCaption.appendChild(document.createTextNode('★ ' + row.rating + '/5'));
      if (row.productHandle && row.productTitle) {
        dialogCaption.appendChild(document.createTextNode(' · '));
        var a = el('a', null, row.productTitle);
        a.href = productUrl(row.productHandle);
        dialogCaption.appendChild(a);
      }
      dialog.showModal();
    }

    if (dialog) {
      root.querySelector('[data-role="lightbox-close"]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    // ---------- dane ----------
    function load() {
      var url = LIST_ENDPOINT + '?limit=' + FETCH_LIMIT + (shopDomain ? '&shop=' + encodeURIComponent(shopDomain) : '') +
        '&locale=' + encodeURIComponent(reviewLocale);
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      }).then(function (data) {
        if (!data || data.success !== true || !Array.isArray(data.rows)) throw new Error('Unexpected response');
        latestAggregate = data.aggregate || null;
        return data.rows;
      });
    }

    function refreshPhotoUrls() {
      if (retried) return;
      retried = true;
      load().then(function (rows) {
        var byId = {};
        rows.forEach(function (r) { byId[r.id] = r; });
        track.querySelectorAll('.hrg-card[data-review-id]').forEach(function (card) {
          var row = byId[card.getAttribute('data-review-id')];
          var img = card.querySelector('.hrg-card__photo img');
          if (row && row.photoUrl && img) {
            card.__hrgRow = row;
            img.src = row.photoThumbUrl || row.photoUrl;
          }
        });
      }).catch(function (err) {
        console.error('[home-reviews] photo refresh failed:', err);
      });
    }

    function render(rows) {
      var picked = pickRows(rows, max);
      if (!picked.length) return;
      var fragment = document.createDocumentFragment();
      picked.forEach(function (row, index) {
        // Pierwsze karty widać od razu; dalsze (poza ekranem karuzeli) ładują się leniwie.
        var card = buildCard(row, i18n, openPhoto, index < 4);
        var img = card.querySelector('.hrg-card__photo img');
        if (img) img.addEventListener('error', refreshPhotoUrls, { once: true });
        fragment.appendChild(card);
      });
      track.innerHTML = '';
      track.appendChild(fragment);
      track.scrollLeft = 0;
      updateArrows();
      updateAggregate();
      root.classList.add('hrg--hydrated');
    }

    function start() {
      load().then(render).catch(function (err) {
        // Karty z serwera zostają — sekcja nadal pokazuje prawdziwe opinie.
        console.error('[home-reviews] reviews not loaded:', err);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          observer.disconnect();
          start();
        }
      }, { rootMargin: '800px 0px' });
      observer.observe(root);
    } else {
      start();
    }
  }

  function init() {
    document.querySelectorAll('[data-hrg]:not([data-hrg-ready])').forEach(function (root) {
      root.setAttribute('data-hrg-ready', '');
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
